export const ROLES = ["ADMINISTRATOR", "USER"];
export const ADMINISTRATOR = ["ADMINISTRATOR"];
export const BACKOFFICE = ["BACKOFFICE"];
export const USER = ["USER"];
